import { Container, OldHeading, Image, SpecialSpan, OldText } from '@gassan-ui'
import { getKontentImage } from '@lib/kontent'
import { TudorLandingpage } from '@lib/kontent/models/TudorLandingpage'
import { FC } from 'react'

type TudorLandingPageHistoryProps = {
  title: string
  preTitle: string
  description: string
  image: TudorLandingpage['history_image']
}

export const TudorLandingPageHistory: FC<TudorLandingPageHistoryProps> = ({
  title,
  preTitle,
  description,
  image,
}) => {
  if (!image.value[0]) return null

  return (
    <Container maxWidth="1024px" className="mb-16 md:mb-24">
      <div className="m-auto text-center">
        <SpecialSpan variant="two" as="h6" color="tudorRed" mb="0">
          {preTitle}
        </SpecialSpan>
        <OldHeading variant="h2" as="h2" color="tudorShade800" mb="4" fontWeight="medium">
          {title}
        </OldHeading>
        <Image
          className="mb-8 aspect-[20/13]"
          sources={[
            getKontentImage(image.value[0].url, { width: 768 }),
            getKontentImage(image.value[0].url, { width: 768 }),
            getKontentImage(image.value[0].url, { width: 1200 }),
            getKontentImage(image.value[0].url, { width: 2000 }),
            getKontentImage(image.value[0].url, { width: 2500 }),
          ]}
          placeholderSrc={getKontentImage(image.value[0].url, { width: 20 })}
          alt={image.value[0].description as string}
        />
        <div className="m-auto w-full md:w-3/4 ">
          <OldText variant="small" color="tudorShade800" className="whitespace-pre-line">
            {description}
          </OldText>
        </div>
      </div>
    </Container>
  )
}
